import React from 'react'

export default function Footer() {
    return (
        <footer>&copy; Copyright 2021 Poojitha Namini</footer>
    )
}
